<apx-chart
    [series]="properties.series"
    [chart]="properties.chart"
    [xaxis]="properties.xaxis"
    [stroke]="properties.stroke"
    [tooltip]="properties.tooltip"
    [colors]="properties.colors"
    [dataLabels]="properties.dataLabels"
    [yaxis]="properties.yaxis"
    [title]="properties.title"
    [legend]="properties.legend"
></apx-chart>